module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Db-Ee-Fb.238d06dc.png";